{
  "pages": {
    "tickets": {
      "title": "Tickets",
      "createTitle": "Créer un ticket",
      "loading": "Chargement du ticket…"
    },
    "reports": {
      "title": "Rapports service client"
    },
    "cannedResponses": {
      "title": "Réponses prédéfinies"
    },
    "inbox": {
      "title": "Boîte de réception"
    },
    "setup": {
      "title": "Configuration service client"
    },
    "workflowDesigner": {
      "title": "Concepteur de workflow"
    },
    "boards": {
      "title": "Tableaux service client"
    },
    "knowledgeBase": {
      "title": "Base de connaissances"
    },
    "automation": {
      "title": "Automatisation service client"
    },
    "liveChat": {
      "title": "Chat en direct"
    },
    "support360": {
      "description": "Support client 360 — tickets, CRM, finance et historique omnicanal",
      "loading": "Chargement du profil support…"
    },
    "dashboard": {
      "title": "Tableau de bord service client",
      "description": "Volume support, santé SLA et état des files selon votre niveau d'accès",
      "queueDetails": "Détails des files",
      "unassigned": "Non assignés",
      "totalTickets": "Total des tickets"
    },
    "ruleBasedTriggersOnTicketAnd": "Rule-based triggers on ticket et SLA events",
    "kanbanViewOfTicketsByWorkflow": "Kanban afficher of tickets by flux de travail status",
    "reusableReplySnippetsForAgents": "Reusable reply snippets pour agents",
    "noCannedResponsesYet": "Aucune réponse prédéfinie pour le moment",
    "emailConversationsLinkedToTicketsReply": "Email conversations linked à tickets — reply via SMTP",
    "categoriesAndArticlesForAgentsAnd": "Categories et articles pour agents et client portal",
    "realtimeCustomerConversations": "Realtime client conversations",
    "ticketVolumeSlaBreachesAndAgent": "Ticket volume, SLA breaches, et agent performance",
    "statuses": "Statuts",
    "priorities": "Priorités",
    "teams": "Teams",
    "statusesPrioritiesTeamsInboundMailboxImap": "Statuses, priorities, teams, inbound mailbox, IMAP polling, client portal, business hours",
    "defineAllowedStatusTransitionsAndRole": "Define allowed status transitions et role ACLs",
    "omnichannelSupportTicketsWithConfigurableWorkflows": "Omnichannel support tickets avec configurable flux de travails"
  },
  "toast": {
    "ticketCreated": "Ticket créé",
    "workflowCreated": "Workflow créé",
    "transitionAdded": "Transition ajoutée",
    "cannedResponseUpdated": "Réponse prédéfinie mise à jour",
    "cannedResponseCreated": "Réponse prédéfinie créée",
    "categoryCreated": "Catégorie créée",
    "articleCreated": "Article créé",
    "imapSettingsSaved": "Paramètres IMAP enregistrés",
    "inboundProcessed": "{{count}} messages entrants traités",
    "replySent": "Réponse envoyée",
    "timelineAdded": "Ajouté à la chronologie",
    "statusUpdated": "Statut mis à jour",
    "attachmentAdded": "Pièce jointe ajoutée",
    "csatRecorded": "CSAT enregistré",
    "reportExported": "Rapport exporté en {{format}}"
  },
  "errors": {
    "loadReportsFailed": "Échec du chargement des rapports service client",
    "exportFailed": "Échec de l'export",
    "createFailed": "Échec de la création",
    "createWorkflowFailed": "Échec de la création du workflow",
    "addTransitionFailed": "Échec de l'ajout de la transition",
    "loadCannedResponsesFailed": "Échec du chargement des réponses prédéfinies",
    "saveFailed": "Échec de l'enregistrement",
    "deleteFailed": "Échec de la suppression",
    "createCategoryFailed": "Échec de la création de la catégorie",
    "createArticleFailed": "Échec de la création de l'article",
    "loadSupport360Failed": "Échec du chargement du Support client 360",
    "loadSetupFailed": "Échec du chargement de la configuration",
    "updateCalendarFailed": "Échec de la mise à jour du calendrier métier",
    "addHolidayFailed": "Échec de l'ajout du jour férié",
    "saveImapFailed": "Échec de l'enregistrement des paramètres IMAP",
    "syncFailed": "Échec de la synchronisation",
    "loadLiveChatsFailed": "Échec du chargement des chats en direct",
    "loadThreadFailed": "Échec du chargement du fil",
    "sendReplyFailed": "Échec de l'envoi de la réponse",
    "loadTicketFailed": "Échec du chargement du ticket",
    "addCommentFailed": "Échec de l'ajout du commentaire",
    "transitionFailed": "Échec de la transition",
    "uploadFailed": "Échec du téléversement",
    "recordCsatFailed": "Échec de l'enregistrement du CSAT",
    "loadInboxFailed": "Échec du chargement de la boîte de réception",
    "loadMessagesFailed": "Échec du chargement des messages",
    "loadAutomationFailed": "Échec du chargement des règles d'automatisation",
    "loadBoardFailed": "Échec du chargement du tableau",
    "failedToLoadQueue": "Échec du chargement de la file",
    "failedToLoadTickets": "Échec du chargement de tickets",
    "updateFailed": "Échec de la mise à jour"
  },
  "labels": {
    "title": "Titre",
    "shortcutCode": "Code de raccourci",
    "categoryCode": "Code de catégorie",
    "body": "Corps",
    "replyToCustomer": "Reply à client",
    "name": "Nom",
    "category": "Catégorie",
    "content": "Contenu",
    "none": "— Aucun —",
    "agentReply": "Réponse de l'agent",
    "totalTickets": "Total des tickets",
    "openTickets": "Tickets ouverts",
    "unassigned": "Non attribué",
    "slaBreaches": "Violations SLA",
    "averageCsat": "CSAT moyen",
    "imapHost": "Hôte IMAP",
    "port": "Port",
    "username": "Nom d'utilisateur",
    "password": "Mot de passe",
    "calendarName": "Nom du calendrier",
    "timezone": "Fuseau horaire",
    "workStart": "Début du travail",
    "workEnd": "Fin du travail",
    "date": "Date",
    "passwordAppPassword": "Mot de passe (mot de passe d'application)",
    "newWorkflowName": "New flux de travail name",
    "fromStatus": "Depuis le statut",
    "toStatus": "Vers le statut",
    "allowedRoleCodeOptional": "Code de rôle autorisé (facultatif)",
    "invoices": "Factures",
    "avgCsat": "CSAT moyen",
    "rating": "Note",
    "feedbackOptional": "Retour (facultatif)",
    "replyNote": "Réponse / note",
    "subject": "Objet *",
    "description": "Descriptif"
  },
  "breadcrumbs": {
    "desk": "Service client",
    "tickets": "Tickets",
    "setup": "Configuration",
    "workflows": "Flux de travails",
    "reports": "Rapports",
    "support360": "Support 360"
  },
  "headings": {
    "workflows": "Flux de travails",
    "transitions": "Transitions"
  },
  "tableHeaders": {
    "from": "De",
    "to": "Vers",
    "role": "Rôle"
  },
  "status": {
    "active": "Actif",
    "inactive": "Inactif"
  },
  "empty": {
    "selectOrCreateWorkflow": "Sélectionnez ou créez un workflow",
    "noTransitionsYet": "Aucune transition pour le moment"
  },
  "workspace": {
    "title": "Espace agent",
    "description": "Espace support centré sur les files pour mes tickets, ceux de l'équipe, les non assignés, les prioritaires et les en retard.",
    "queues": {
      "MY": "Mes tickets",
      "TEAM": "Équipe",
      "UNASSIGNED": "Non assignés",
      "PRIORITY": "Prioritaires",
      "OVERDUE": "En retard"
    },
    "columns": {
      "ticket": "Ticket",
      "subject": "Sujet",
      "source": "Origine",
      "assignee": "Assigné à",
      "sla": "SLA"
    },
    "values": {
      "unassigned": "Non assigné"
    },
    "actions": {
      "bulkAssignmentConsole": "Console d'assignation en lot",
      "save": "Enregistrer"
    },
    "savedViews": {
      "title": "Vues enregistrées",
      "viewName": "Nom de la vue",
      "empty": "Aucune vue enregistrée pour le moment"
    }
  },
  "cannedResponses": {
    "actions": {
      "delete": "Supprimer",
      "edit": "Modifier"
    },
    "columns": {
      "actions": "Opérations",
      "shortcut": "Raccourci",
      "title": "Titre"
    },
    "confirmDeleteMessage": "Cet extrait sera supprimé pour tous les agents.",
    "confirmDeleteTitle": "Supprimer la réponse prédéfinie",
    "editResponse": "Modifier la réponse",
    "newResponse": "Nouvelle réponse"
  },
  "ticketsList": {
    "columns": {
      "ticket": "Ticket",
      "subject": "Sujet",
      "status": "Statut",
      "priority": "Priorité",
      "source": "Origine",
      "sla": "SLA",
      "assignee": "Assigné à",
      "tags": "Étiquettes"
    },
    "filters": {
      "status": "Statut",
      "priority": "Priorité",
      "team": "Équipe",
      "sla": "SLA",
      "tag": "Étiquette"
    },
    "bulk": {
      "assignEmployeeId": "ID employé à assigner",
      "status": "Statut en lot",
      "addTag": "Ajouter un tag"
    },
    "actions": {
      "selectTicket": "Sélectionner {{ticketNumber}}",
      "clearPage": "Effacer la page",
      "selectPage": "Sélectionner la page",
      "apply": "Appliquer",
      "delete": "Supprimer"
    },
    "sla": {
      "overdue": "En retard",
      "dueSoon": "Bientôt dû",
      "overduePrefix": "En retard ",
      "duePrefix": "Dû "
    }
  },
  "ticketDetail": {
    "activeViewers": "Consultent aussi : {{viewers}}",
    "sections": {
      "details": "Détails",
      "editableMetadata": "Métadonnées modifiables",
      "tags": "Étiquettes",
      "customFields": "Champs personnalisés",
      "relatedTickets": "Tickets liés",
      "followers": "Abonnés",
      "mentions": "Mentions",
      "knowledgeSuggestions": "Suggestions de connaissances",
      "timeTracking": "Suivi du temps",
      "assetsAndProducts": "Actifs et produits",
      "projectLinks": "Liens projet",
      "changeStatus": "Changer le statut",
      "attachments": "Pièces jointes",
      "csat": "Satisfaction client (CSAT)",
      "ticketTimeline": "Chronologie du ticket"
    },
    "labels": {
      "customer": "Client :",
      "due": "Dû : {{date}}",
      "subject": "Sujet",
      "description": "Descriptif",
      "assignedEmployeeId": "ID employé assigné",
      "priority": "Priorité",
      "team": "Équipe",
      "addTag": "Ajouter un tag",
      "fieldKey": "Clé du champ",
      "fieldValue": "Valeur du champ",
      "relatedTicketId": "ID du ticket lié",
      "linkType": "Type de lien",
      "employeeWithId": "Employé #{{employeeId}}",
      "followerEmployeeId": "ID employé abonné",
      "mentionedFrom": "Employé #{{employeeId}} mentionné depuis {{source}}",
      "manualMinutes": "Minutes manuelles",
      "notes": "Notes",
      "billable": "Facturable",
      "productId": "ID produit",
      "assetId": "ID actif",
      "serialNumber": "Numéro de série",
      "warrantyEndDate": "Fin de garantie (AAAA-MM-JJ)",
      "serviceNotes": "Notes de service",
      "assetWithId": "Actif #{{assetId}}",
      "warrantyActive": "Garantie active",
      "productWithId": "Produit #{{productId}}",
      "warrantyEnd": "Fin de garantie {{date}}",
      "projectId": "ID projet",
      "issueId": "ID issue",
      "taskId": "ID tâche",
      "projectWithId": "Projet #{{projectId}}",
      "issueWithId": "Issue #{{issueId}}",
      "taskWithId": "Tâche #{{taskId}}",
      "internalNote": "Note interne"
    },
    "placeholders": {
      "description": "Descriptif",
      "priority": "Priorité",
      "team": "Équipe"
    },
    "actions": {
      "saveMetadata": "Enregistrer les métadonnées",
      "removeShort": "retirer",
      "add": "Ajouter",
      "saveField": "Enregistrer le champ",
      "remove": "Retirer",
      "linkTicket": "Lier le ticket",
      "follow": "S'abonner",
      "insert": "Insérer",
      "addTime": "Ajouter du temps",
      "startTimer": "Démarrer le minuteur",
      "stop": "Arrêter",
      "linkAsset": "Lier l'actif",
      "linkProject": "Lier le projet",
      "uploadFile": "Téléverser un fichier",
      "recordCsat": "Enregistrer le CSAT"
    },
    "empty": {
      "noDescription": "Aucune description",
      "noTags": "Aucun tag",
      "noCustomFields": "Aucun champ personnalisé",
      "noRelatedTickets": "Aucun ticket lié",
      "noFollowers": "Aucun abonné",
      "noMentions": "Aucune mention",
      "noArticleSuggestions": "Aucune suggestion d'article",
      "noTimeEntries": "Aucune entrée de temps",
      "noLinkedAssets": "Aucun actif lié",
      "noProjectLinks": "Aucun lien projet",
      "noAttachments": "Aucune pièce jointe",
      "noTimelineItems": "Aucun élément dans la chronologie"
    },
    "help": {
      "mentions": "Mentionnez des employés dans les commentaires avec @employeeId, par exemple @123."
    },
    "linkTypes": {
      "related": "Lié",
      "parent": "Parent",
      "child": "Enfant",
      "duplicate": "Doublon",
      "blocks": "Bloque"
    },
    "projectLinkTypes": {
      "projectIssue": "Issue projet",
      "projectBug": "Bug projet",
      "projectTask": "Tâche projet",
      "escalation": "Escalade"
    },
    "time": {
      "running": "En cours",
      "minutes": "min",
      "billableSuffix": " · facturable",
      "runningSuffix": " - en cours"
    },
    "timeline": {
      "internalSuffix": " · interne"
    }
  },
  "formActions": {
    "saveImap": "Enregistrer IMAP",
    "saveCalendar": "Enregistrer le calendrier",
    "addHoliday": "Ajouter un jour férié",
    "addTransition": "Ajouter une transition",
    "createWorkflow": "Créer un workflow",
    "addToTimeline": "Ajouter à la chronologie"
  },
  "listActions": {
    "newTicket": "Nouveau ticket",
    "workflowDesigner": "Concepteur de flux de travail",
    "cannedResponses": "Réponses prédéfinies",
    "sendReply": "Envoyer la réponse"
  }
}
